import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Plus, Minus } from "lucide-react";
import { PageHead, Wrap } from "@/components/Content";

const FAQS = [
  ["Do you guarantee a grade, a PSA 10, or a higher grade?",
    "No. We do not promise PSA 10s or any specific grade from any grading company. We do not promise that cleaning will increase a grade or increase monetary value, and we do not promise that a collectible will be accepted by a grading company. Independent grading companies determine their own grades under their own standards."],
  ["Are you affiliated with PSA, CGC, Beckett or SGC?",
    "No. CardScience HQ is not affiliated with, endorsed by, sponsored by or approved by PSA, CGC, Beckett, SGC or any other independent grading company unless explicitly stated otherwise — including when customers later submit serviced cards for grading."],
  ["What collectibles do you work with?",
    "Pokémon, baseball, football, basketball, hockey, soccer and other sports cards, trading cards, TCG cards, vintage and modern cards, comic books (vintage, modern, key issues, raw), stamps and other collectible paper-based items that CardScience HQ specifically agrees to evaluate."],
  ["Do you clean comics the same way you clean cards?",
    "No. The methods we use on a trading card are not the methods we use on a comic book. Comics require different intake, protection and treatment rules. Not every comic can be treated, and every collectible is evaluated individually."],
  ["Why might my card be turned away?",
    "More than 30% of the cards we evaluate are turned away because we believe the risk outweighs the potential benefit, the damage cannot responsibly be addressed, the collectible is not appropriate for our process, or the proposed service would provide little meaningful benefit. Turning away a collectible is part of our process — not a failure of it."],
  ["Can I ship my collectible before I'm approved?",
    "No. Every collectible must first go through our submission process. You must receive approval and shipping instructions before sending anything. A shipment sent outside our approved process may be refused, rejected or returned. No approved submission, no shipment, no exceptions."],
  ["What are the $50+ and $500+ requirements?",
    "For collectibles with a declared value of $50 or more, we use a documented return-packing process (video and photos of the collectible, packaging and sealing where practical). Any collectible with a declared value of $500 or more must use the insurance requirements we specify. You are responsible for accurately declaring value."],
  ["Is my submission confidential?",
    "Yes. Confidentiality is part of our service — 100% client confidentiality. We will never intentionally disclose your identity, your collection's contents or value, grading results, submission details or your use of our services without your authorization, except where legally required."],
  ["What will you never do to my card?",
    "We do not trim cards, recolor cards, manufacture corners, add material to conceal damage, or intentionally misrepresent condition. Our goal is never to manufacture condition that does not exist."],
];

function Item({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[color:var(--line)] rounded-2xl overflow-hidden">
      <button
        data-testid="faq-toggle"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-white/[0.02] transition-colors"
      >
        <span className="text-white font-semibold">{q}</span>
        {open ? <Minus size={18} className="text-[color:var(--cyan)] shrink-0" /> : <Plus size={18} className="text-[color:var(--chrome-2)] shrink-0" />}
      </button>
      {open && <p className="px-6 pb-6 text-[color:var(--chrome-2)] leading-relaxed">{a}</p>}
    </div>
  );
}

export default function FAQ() {
  return (
    <div className="bg-ink min-h-screen pb-24">
      <PageHead eyebrow="FAQ" title="QUESTIONS, ANSWERED HONESTLY." tone="violet" />
      <Wrap className="py-16">
        <div className="space-y-3">
          {FAQS.map(([q, a]) => <Item key={q} q={q} a={a} />)}
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/submit" className="btn-holo inline-flex items-center gap-2 rounded-xl px-7 py-4 text-sm">SUBMIT A COLLECTIBLE <ArrowRight size={16} /></Link>
          <Link to="/contact" className="btn-ghost inline-flex items-center gap-2 rounded-xl px-7 py-4 text-sm">CONTACT US</Link>
        </div>
      </Wrap>
    </div>
  );
}
